"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMsgSellNFT = exports.formatMsgDeleteOffer = exports.formatMsgUpdateOffer = exports.formatMsgCreateOffer = exports.formatMsgBuyNFT = exports.formatMsgDeleteListing = exports.formatMsgUpdateListing = exports.formatMsgCreateListing = exports.formatMsgDeleteRoyaltyConfig = exports.formatMsgUpdateRoyaltyConfig = exports.formatMsgCreateRoyaltyConfig = exports.formatMsgBurnNFT = exports.formatMsgSend = exports.formatMsgMintNFT = exports.formatMsgUpdateClass = exports.formatMsgNewClass = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const long_1 = __importDefault(require("long"));
const buffer_1 = require("buffer/");
function formatMsgNewClass(senderAddress, iscnIdPrefix, nftClassData, classConfig) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgNewClass',
    value: {
      creator: senderAddress,
      parent: {
        type: 1,
        iscnIdPrefix
      },
      input: {
        name: nftClassData.name,
        symbol: nftClassData.symbol,
        description: nftClassData.description,
        uri: nftClassData.uri,
        uriHash: nftClassData.uriHash,
        metadata: buffer_1.Buffer.from(JSON.stringify(Object.assign({}, nftClassData.metadata || {})), 'utf8'),
        config: classConfig || {
          burnable: false
        }
      }
    }
  };
  return message;
}
exports.formatMsgNewClass = formatMsgNewClass;
function formatMsgUpdateClass(senderAddress, classId, nftClassData, classConfig) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgUpdateClass',
    value: {
      creator: senderAddress,
      classId,
      input: Object.assign(Object.assign({}, nftClassData), {
        config: classConfig || {
          burnable: false
        }
      })
    }
  };
  return message;
}
exports.formatMsgUpdateClass = formatMsgUpdateClass;
function formatMsgMintNFT(senderAddress, classId, nftData) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgMintNFT',
    value: {
      creator: senderAddress,
      classId,
      id: nftData.id,
      input: {
        uri: nftData.uri,
        uriHash: nftData.uriHash,
        metadata: buffer_1.Buffer.from(JSON.stringify(Object.assign({}, nftData.metadata || {})), 'utf8')
      }
    }
  };
  return message;
}
exports.formatMsgMintNFT = formatMsgMintNFT;
function formatMsgSend(senderAddress, receiverAddress, classId, nftId) {
  const message = {
    typeUrl: '/cosmos.nft.v1beta1.MsgSend',
    value: {
      sender: senderAddress,
      receiver: receiverAddress,
      classId,
      id: nftId
    }
  };
  return message;
}
exports.formatMsgSend = formatMsgSend;
function formatMsgBurnNFT(senderAddress, classId, nftId) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgBurnNFT',
    value: {
      creator: senderAddress,
      classId,
      nftId
    }
  };
  return message;
}
exports.formatMsgBurnNFT = formatMsgBurnNFT;
function formatMsgCreateRoyaltyConfig(senderAddress, classId, royaltyConfig) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgCreateRoyaltyConfig',
    value: {
      creator: senderAddress,
      classId,
      royaltyConfig
    }
  };
  return message;
}
exports.formatMsgCreateRoyaltyConfig = formatMsgCreateRoyaltyConfig;
function formatMsgUpdateRoyaltyConfig(senderAddress, classId, royaltyConfig) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgUpdateRoyaltyConfig',
    value: {
      creator: senderAddress,
      classId,
      royaltyConfig
    }
  };
  return message;
}
exports.formatMsgUpdateRoyaltyConfig = formatMsgUpdateRoyaltyConfig;
function formatMsgDeleteRoyaltyConfig(senderAddress, classId) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgDeleteRoyaltyConfig',
    value: {
      creator: senderAddress,
      classId
    }
  };
  return message;
}
exports.formatMsgDeleteRoyaltyConfig = formatMsgDeleteRoyaltyConfig;
function formatMsgCreateListing(senderAddress, classId, nftId, price, expiration) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgCreateListing',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      price: long_1.default.fromString(price),
      expiration: expiration ? new Date(expiration) : new Date(Date.now() + 86400 * 180)
    }
  };
  return message;
}
exports.formatMsgCreateListing = formatMsgCreateListing;
function formatMsgUpdateListing(senderAddress, classId, nftId, price, expiration) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgUpdateListing',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      price: long_1.default.fromString(price),
      expiration: expiration ? new Date(expiration) : new Date(Date.now() + 86400 * 180)
    }
  };
  return message;
}
exports.formatMsgUpdateListing = formatMsgUpdateListing;
function formatMsgDeleteListing(senderAddress, classId, nftId) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgDeleteListing',
    value: {
      creator: senderAddress,
      classId,
      nftId
    }
  };
  return message;
}
exports.formatMsgDeleteListing = formatMsgDeleteListing;
function formatMsgBuyNFT(senderAddress, classId, nftId, seller, price) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgBuyNFT',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      seller,
      price: long_1.default.fromString(price)
    }
  };
  return message;
}
exports.formatMsgBuyNFT = formatMsgBuyNFT;
function formatMsgCreateOffer(senderAddress, classId, nftId, price, expiration) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgCreateOffer',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      price: long_1.default.fromString(price),
      expiration: expiration ? new Date(expiration) : new Date(Date.now() + 86400 * 180)
    }
  };
  return message;
}
exports.formatMsgCreateOffer = formatMsgCreateOffer;
function formatMsgUpdateOffer(senderAddress, classId, nftId, price, expiration) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgUpdateOffer',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      price: long_1.default.fromString(price),
      expiration: expiration ? new Date(expiration) : new Date(Date.now() + 86400 * 180)
    }
  };
  return message;
}
exports.formatMsgUpdateOffer = formatMsgUpdateOffer;
function formatMsgDeleteOffer(senderAddress, classId, nftId) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgDeleteOffer',
    value: {
      creator: senderAddress,
      classId,
      nftId
    }
  };
  return message;
}
exports.formatMsgDeleteOffer = formatMsgDeleteOffer;
function formatMsgSellNFT(senderAddress, classId, nftId, buyer, price) {
  const message = {
    typeUrl: '/likechain.likenft.v1.MsgSellNFT',
    value: {
      creator: senderAddress,
      classId,
      nftId,
      buyer,
      price: long_1.default.fromString(price)
    }
  };
  return message;
}
exports.formatMsgSellNFT = formatMsgSellNFT;